import React from "react";
import {
  BannerDesc,
  FormCol,
  FormSection,
  PhaseEBookBannerSection,
  SectionTitle,
} from "./style";
import { GlobalContainer } from "../../Global/layout";
import { Col, Row } from "antd";
import { StyledHeadingh2 } from "../../Global/headings";
import CaresPhase4eBookDownload from "../../Form/CaresPhase4eBookDownload";

const Phase4EBookBanner = ({ data }: any) => {
  return (
    <section className="light">
      <PhaseEBookBannerSection>
        <GlobalContainer>
          <Row>
            <Col xs={24} sm={24} md={24} lg={13} xl={13}>
              <StyledHeadingh2
                style={{ marginBottom: "50px" }}
                maxWidth="715px"
                text={data?.heading}
              />
              <BannerDesc
                data-aos="fade-up"
                dangerouslySetInnerHTML={{
                  __html: data?.content,
                }}
              />
            </Col>
            <FormCol
              data-aos="fade-up"
              id="Form"
              xs={24}
              sm={24}
              md={24}
              lg={11}
              xl={11}
            >
              <FormSection>
                <SectionTitle>Get in touch</SectionTitle>
                <CaresPhase4eBookDownload Subtitle="to learn strategies to enhance conversions." />
              </FormSection>
            </FormCol>
          </Row>
        </GlobalContainer>
      </PhaseEBookBannerSection>
    </section>
  );
};

export default Phase4EBookBanner;
